export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const API_HOST = API_URL.split("/")[2];
